/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetUnreadChatsCountResult } from '../../models/get-unread-chats-count-result';

export interface GetUnreadCount$Params {}

export function getUnreadCount(
  http: HttpClient,
  rootUrl: string,
  params?: GetUnreadCount$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<GetUnreadChatsCountResult>> {
  const rb = new RequestBuilder(rootUrl, getUnreadCount.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetUnreadChatsCountResult>;
    }),
  );
}

getUnreadCount.PATH = '/Chats/unread-count';
